/** @jsxImportSource theme-ui */
import styled from '@emotion/styled';
import { Input } from '@theme-ui/components';
import { theme } from 'app/theme';

export const InputStyled = styled(Input)`
    border-radius: ${theme.forms.input.borderRadius};
    border: 1px solid ${(props) => (props.invalid ? theme.colors.error : theme.colors.medium )};
    background: transparent;
    width: 100%;
    text-overflow: ellipsis;
    padding-left: 14px;
    background-color: white;
    line-height: 1;
    padding: 13px 14px;
    background-color: white;
    transition: border-color 0.3s ease-in-out;

    &::-ms-clear {
        display: none;
    }

    ::-webkit-input-placeholder {
        color: ${theme.colors.placeholder};
    }

    :disabled {
        color: ${theme.colors.disabled};
        background-color: ${theme.colors.disabledBackground};
    }

    &:focus, &:not(:disabled):hover {
        outline: none;
        border-color: ${theme.colors.tealDark};
    }

    &:focus {
        font-weight: 700;
    }
`;
